import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getModerationItemsKey } from '../../utils/keys';
export const useModerationItems = (options) => {
    const { variables, fields = 'basic', useInfiniteQueryOptions } = options || {};
    const { client } = useTribeClient();
    const moderationItemsKey = getModerationItemsKey(variables);
    return useInfiniteQuery(moderationItemsKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.moderation.getItems({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useModerationItems.js.map